import { loopThroughElements } from "./loop-through-elements";

export function touchAllInputs(form: HTMLFormElement): void {
    const trigger = (el: HTMLElement): void => {
        try {
            el.focus();
        } catch (e) {
            const fe = el as HTMLInputElement;
            console.log(`Could not focus ${fe.name}.`);
        }
    }
    loopThroughElements(form.getElementsByTagName('input'), trigger);
    loopThroughElements(form.getElementsByTagName('select'), trigger);
}